import '../components/innerpages/innerpages.scss'

import React from 'react';
import { Helmet } from 'react-helmet';

import GalleryGrid from '../components/innerpages/gallery/GalleryGrid';
import Header from '../components/innerpages/gallery/Header';

function gallery() {
  return (
    <>
      <Helmet>
        <script src="/common/assets/js/common_js.js"></script>
        <script src="/innerpages/assets/js/innerpages.js"></script>
      </Helmet>
      <div className="inner-pages-style1 gallery-pg-style1">
        <div className="smooth-scroll-content" id="scrollsmoother-container">
          <Header />
          <GalleryGrid />
        </div>
      </div>
    </>
  );
}

export default gallery;